export default [
  {
    title: 'Información Escolar',
    group: 'information',
    items: [
      {
        title: 'Mi Información',
        group: '(personal|familiar|socioeconomica|trabajo)',
        namespace: 'information',
        items: [
          { name: 'personal', title: 'Personal' },
          { name: 'familiar', title: 'Familiar' },
          { name: 'socioeconomica', title: 'Socioeconómica' },
          { name: 'trabajo', title: 'Trabajo' }
        ]
      },
      {
        title: 'Servicio Social',
        group: '(servicio-social)',
        namespace: 'information',
        items: [
          { name: 'servicio-social', title: 'Realizar Solicitud' },
          { name: 'servicio-social-descargas', title: 'Descargas' },
          { name: 'servicio-social-reportes', title: 'Reportes' }
        ]
      },
      {
        title: 'Residencia',
        group: '(residencia-profesional)',
        namespace: 'information',
        items: [
          { name: 'residencia-profesional', title: 'Solicitud de Residencia Profesional' },
          { name: 'residencia-profesional-descargas', title: 'Descargas' }
        ]
      },
      { name: 'boleta', title: 'Boleta de Calificaciones' },
      { name: 'horario', title: 'Horario' },
      { name: 'kardex', title: 'Kardex' },
      { name: 'avance-reticular', title: 'Avance Reticular' },
      { name: 'calificaciones-parciales', title: 'Calificaciones Parciales' },
      { name: 'instrumentacion-didactica', title: 'Instrumentación Didáctica' },
      { name: 'gestion-curso', title: 'Gestion del Curso' }
    ]
  },
  {
    title: 'Inscripciones',
    group: 'inscripciones',
    items: [
      { name: 'referencia-bancaria', title: 'Referencia Bancaria' },
      { name: 'grupos-disponibles', title: 'Grupos Disponibles' },
      { name: 'reinscripcion', title: 'Reinscripción' },
      { name: 'extra-escolar', title: 'ExtraEscolar' }
    ]
  },
  {
    title: 'Evaluacion docente',
    group: 'evaluacion-docente',
    items: [
      { name: 'evaluacion-docente', title: 'Realizar Evaluación' },
      { name: 'evaluaciones-realizadas', title: 'Evaluaciones Realizadas' }
    ]
  },
  {
    title: 'Documentos Oficiales',
    group: 'doctos-oficiales',
    items: [
      { name: 'solicitar', title: 'Solicitar' },
      { name: 'consultar', title: 'Consultar' }
    ]
  },
  {
    title: 'Encuesta de Servicios',
    name: 'EncuestaServicios',
    icon: 'playlist_add_check'
  },
  {
    title: 'Buzón de quejas y/o sugerencias',
    icon: 'mail',
    name: 'Buzon'
  }
]



// WEBPACK FOOTER //
// ./src/data/layout/app-drawer-items.js